<div class="container-fluid">
    <app-page-header header="{{pageTitle}}" description="{{pageSubTitle}}"></app-page-header>
    <div class="release-main-container">
        <div class="release-toolbar-row">
            <p class="release-title">
                Release: {{ releaseName }}
            </p>
            <button mat-icon-button class="refresh-btn" (click)="refreshTable()" [disabled]="isRefreshing" matTooltip="Click to view the latest status">
                <mat-icon>refresh</mat-icon>
            </button>
        </div>
        <ag-grid-angular id="gridManifest" #agGrid 
            class="ag-theme-material manifest-grid"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            [rowModelType]="'serverSide'"
            [suppressMenuHide]="false"
            [overlayNoRowsTemplate]="overlayNoRowsTemplate"
            [quickFilterText]="quickFilterValue"
            [infiniteInitialRowCount]="infiniteInitialRowCount"
            (gridReady)="onGridReady($event)"
            [headerHeight]="35">
        </ag-grid-angular>
    </div>
</div>